export class ReadNotification {
    public static readonly type = '[Notifications] Read notification';

    constructor(public notificationId: string) {}
}
